<template>
  <div class="personnel-portrait-content">
    <div class="content">
      <div class="content-row">
        <div class="content-column">
          <div class="header-style">
            <div>
              <label class="select-label-style">审核状态: </label>
              <el-select
                v-model="checkStatus"
                size="mini"
                @change="onSelectChange"
              >
                <el-option
                  v-for="item in checkStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div>
              <label class="select-label-style">供应商: </label>
              <el-select
                clearable
                multiple 
                v-model="outsourcer_id"
                size="mini"
                @change="onSelectChange"
              >
                <el-option
                  v-for="item in supplierOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div>
              <label class="select-label-style">产线: </label>
              <el-select
                clearable
                multiple 
                v-model="production_line_code"
                size="mini"
                @change="onSelectChange"
              >
                <el-option
                  v-for="item in productionLineOptions"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <a style="font-size: 14px" @click="batchCheck">批量审批</a>
          </div>
          <lb-table
            :column="productLineCheckerTable.column"
            :data="productLineCheckerTable.data"
            :pagination="true"
            :page-size="productLineCheckerTable.pageSize"
            :total="productLineCheckerTable.totalCount"
            :current-page="productLineCheckerTable.pageNo"
            @current-change="onPageNoChange"
            @sort-change="onTableChange"
            border
            @selection-change="handleSelectionChange"
          >
          </lb-table>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div slot="title" class="dialog-head">
        异常合理性判定:
      </div>
      <div>
        <label style="margin-right: 20px">异常原因来源:</label>
        <el-radio v-model="isRational" :label="1">合理</el-radio>
        <el-radio v-model="isRational" :label="2">不合理</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitCheck(false)">提交审核</el-button>
        <el-button size="mini" @click="dialogVisible = false" style="margin-left: 30px">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import LbTable from '@/components/lb-table/lb-table'
import { checkStatusOptions, productLineCheckerTable } from './config'
import { getCheckList, postCheckSave, outsourcerApi, productionLineApi } from '@/api/personnelWorkHour'

export default {
  name: 'CheckProductionLine',
  components: {
    LbTable
  },
  data () {
    return {
      checkStatusOptions,
      productLineCheckerTable,
      checkStatus: 0,
      supplierOptions: [],
      productionLineOptions: [],
      outsourcer_id: [],
      production_line_code: [],
      dialogVisible: false,
      isRational: 1,
      selection: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    batchCheck () {
      this.dialogVisible = true
    },
    onTableChange (e) {
      // eslint-disable-next-line camelcase
      const { prop: sort_field, order: sort_order } = e
      this.getTableData({ sort_field, sort_order })
    },
    init () {
      this.setTableSlot(this)
      this.optionsInit()
      this.getTableData()
    },
    setTableSlot (ctx) {
      this.productLineCheckerTable.column.push({
        label: '异常原因来源合理性判断',
        width: 180,
        render: function (h, scope) {
          function changeSelect (value) {
            ctx.isRational = value
            ctx.submitCheck(scope.row.id)
          }
          return (
            <el-select
              size={'mini'}
              value={scope.row.is_checked !== '未审核' ? scope.row.is_rational : undefined}
              disabled={scope.row.is_checked !== '未审核'}
              onchange={changeSelect}
            >
              <el-option
                label='不合理'
                value={2}
              />
              <el-option
                label='合理'
                value={1}
              />
            </el-select>
          )
        }
      })
    },
    optionsInit () {
      outsourcerApi().then(res => {
        this.supplierOptions = res
      })
      productionLineApi().then(res => {
        this.productionLineOptions = res
      })
    },
    // 获取审核表数据
    async getTableData (params) {
      // eslint-disable-next-line camelcase
      const { is_checked, pageNo, pageSize, column } = this.productLineCheckerTable
      const outsourcer_id = this.outsourcer_id.join(',')
      const production_line_code = this.production_line_code.join(',')
      const res = await getCheckList({ outsourcer_id, production_line_code, is_checked, pageNo, pageSize, ...params })
      // eslint-disable-next-line camelcase
      res.is_checked = is_checked
      res.column = column
      this.productLineCheckerTable = res
    },
    // 多选选项改变回掉
    handleSelectionChange (selection) {
      this.selection = selection.map(item => item.id)
    },
    handleClose () {
      this.$confirm({
        title: '确认要关闭吗？',
        zIndex: 99999,
        onOk: () => {
          this.dialogVisible = false
        },
        onCancel () {

        }
      })
    },
    submitCheck (id) {
      this.dialogVisible = false
      postCheckSave(
        {
          id: id && [id] || this.selection,
          is_rational: this.isRational
        }).then(_ => {
        this.$notification.success({
          message: '成功',
          description:
            '审核成功'
        })
        this.getTableData()
      })
    },
    onPageNoChange (pageNo) {
      if (typeof pageNo === 'number' && !isNaN(pageNo)) {
        this.getTableData({ pageNo, is_checked: this.checkStatus })
      }
    },
    // eslint-disable-next-line camelcase
    onSelectChange (is_checked) {
      this.getTableData({ is_checked: this.checkStatus, pageNo: 1 })
    }
  }
}
</script>

<style scoped lang="less">
@import "../../utils/utils";

.select-label-style {
  font-size: 14px;
}

.header-style {
  // display: flex;
  // justify-content: space-between;
  margin: 20px 0;
  div {
    display: inline-block;
    margin: 0 10px 0 0;
  }
  a {
    float: right;
  }
}
.dialog-head{
  border-left: 5px solid #5ABFE8;
  padding-left: 10px;
  font-size: 14px;
}
.dialog-footer{
  display: flex;
  justify-content: center;
}
</style>
